import Heading from 'components/Heading'
import React from 'react'

import changeGearboxButton from './Images/change-gearbox-button.png'
import changeGearboxCargoEvents from './Images/change-gearbox-cargo-events.png'
import changeGearboxEnterNOGerbox from './Images/change-gearbox-enter-no.gearbox.png'
import changeGearboxLogGearbox from './Images/change-gearbox-log-gearbox.png'
import changeGearboxPopup from './Images/change-gearbox-popup.png'
import changeGearboxSelect from './Images/change-gearbox-select.png'

const ChangeGearbox = () => (
  <div>
    <Heading isDark level={2}>
      Change Gearbox count
    </Heading>

    <p>Follow the below steps to update the gearbox count.</p>

    <Heading isDark level={3}>
      Cargo Events
    </Heading>
    <img src={changeGearboxCargoEvents} />
    <p>Press ‘Cargo Events’ on the screen.</p>

    <Heading isDark level={3}>
      Log gearboxes onboard
    </Heading>
    <img src={changeGearboxLogGearbox} />
    <p>Press ‘Log gearboxes onboard’ on the screen.</p>

    <Heading isDark level={3}>
      Change gearboxes
    </Heading>
    <img src={changeGearboxButton} />
    <p>Press ‘Change gearboxes’ button.</p>

    <Heading isDark level={3}>
      Number of gearboxes
    </Heading>
    <img src={changeGearboxEnterNOGerbox} />
    <p>Change the number of gearbox count and press ‘ok’ button.</p>
    <img src={changeGearboxPopup} />
    <p>Press ‘ok’ button to confirm the change.</p>

    <Heading isDark level={3}>
      Final result
    </Heading>
    <img src={changeGearboxSelect} />
    <p>Gearbox count change is applied.</p>
  </div>
)

export default ChangeGearbox
